	import classNames from 'classnames';
	import React, { useEffect, useMemo, useRef, useState } from 'react';
	import { Groupper } from 'react-frontier';
	import { formatTimeRange } from '../SiteUtil';

	interface TimeViewProps{
		times: {
			start: number,
			end: number,
			text?: string,
			onClick?: ()=>void,
		}[],
	}

	interface ScheduleViewProps{
		title?: string,
		actions?: any,
		style?: React.CSSProperties,
		width?: number,
		schedule: {
			text: string,
			times: TimeViewProps["times"]
		}[],
	}

	type RenderTimeItems = (TimeViewProps['times'][0] & { type: 'empty' | 'time' });

	var TimeView = (props: TimeViewProps)=>{
		var [width, setWidth] = useState<number>(0);
		var timeRef = useRef<HTMLDivElement>(null);

		useEffect(()=>{
			if(!!timeRef.current && width===0){
				setWidth(timeRef.current.clientWidth);
			}
		}, [timeRef.current, timeRef.current?.clientWidth]);

		var time_items : RenderTimeItems[] = useMemo(()=>{
			if (props.times.length === 0) {
				return [];
			}
			var time_items : RenderTimeItems[] = [];
			for(var i of props.times.sort((a,b)=>a.start-b.start)){
				time_items.push({
					...i,
					type: 'time'
				});
			}
			return time_items.sort((a,b)=>a.start-b.start);
		}, [props.times]);
		
		if (time_items.length === 0) {
			return <div className="schedule" ref={timeRef}>
				<div className="time-wrapper" style={{ width: '100%', position: 'relative' }}>
					<div 
						className="time-background"
						style={{ 
							width: '100%',
							height: '35px',
							backgroundColor: '#e0e0e0',
							borderRadius: '35px',
							position: 'absolute',
							top: 0,
							left: 0
						}}
					/>
					<div className="time empty" style={{ 
						width: '100%',
						position: 'absolute',
						top: 0,
						left: 0,
						height: '35px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}>
						<div style={{ textAlign: 'center', color: 'black' }}>Sin horario asignado</div>
					</div>
				</div>
			</div>
		}

		return <div className="schedule" ref={timeRef} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
			{!!timeRef.current && time_items.map((a, idx)=>{
				var startHour = a.start;
				var endHour = a.end;
				
				if (a.text) {
					var match = a.text.match(/(\d{2}):(\d{2})\s*-\s*(\d{2}):(\d{2})/);
					if (match) {
						startHour = parseInt(match[1]) + parseInt(match[2]) / 60;
						endHour = parseInt(match[3]) + parseInt(match[4]) / 60;
					}
				}
				
				var startPercent = (startHour / 24) * 100;
				var widthPercent = ((endHour - startHour) / 24) * 100;
				
				return (
					<div 
						key={`time-${idx}`}
						className="time-wrapper"
						style={{ width: '100%', position: 'relative', height: '35px' }}
					>
						<div 
							className="time-background"
							style={{ 
								width: '100%',
								height: 35,
								backgroundColor: '#e0e0e0',
								borderRadius: 35,
								position: 'absolute',
								top: 0,
								left: 0
							}}
						/>
						<div 
							className={classNames("time", { 
								clickable: !!a.onClick
							})} 
							style={{ 
								position: 'absolute',
								left: `${startPercent}%`,
								width: `${widthPercent}%`,
								cursor: a.onClick ? 'pointer' : 'default',
								top: 0,
								height: 35,
								borderRadius: 35,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								fontSize: 
								14
							}}
							onClick={a.onClick}
						>
							{a.text || formatTimeRange(startHour, endHour)}
						</div>
					</div>
				);
			})}
		</div>
	}

	var ScheduleView = (props: ScheduleViewProps)=>{
		var labelWidth = props.width ? Math.min(120, props.width * 0.2) : 120;
		var fontSize = props.width && props.width < 600 ? 12 : 15;
		var padding = props.width && props.width < 600 ? 12 : 15;

		return <Groupper title={props.title} titleRight={props.actions} className='fitted schedule-view' style={props.style} width={props.width || 900}>
			{props.schedule.map((a, i)=>(
				<div className="row" key={`SCHVW-${i}`}>
					<div className="label" style={{ 
						paddingTop: padding, 
						paddingBottom: padding,
						minWidth: `${labelWidth}px`,
						maxWidth: `${labelWidth}px`,
						fontSize: fontSize
					}}>{a.text}</div>
					<div style={{ flex: 1, paddingTop: '10px', paddingBottom: '10px' }}>
						<TimeView times={a.times} />
					</div>
				</div>
			))}
		</Groupper>
	}

	export default ScheduleView;